import * as types from '../constants/action-types';

const initialState = {
  error: '',
  isFetching: false,
  hasFetched: false,
  feeTypes: [],
  regions: []
};

export function fetchRegionalFeesRequest (isFetching) {
  return {
    type: types.REGIONAL_FEES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchRegionalFeesSuccess (data) {
  return {
    type: types.REGIONAL_FEES_FETCH_SUCCESS,
    data
  };
}

export function fetchRegionalFeesFailure (fetchError) {
  return {
    type: types.REGIONAL_FEES_FETCH_FAILURE,
    fetchError
  };
}

export default function fees (state = initialState, action) {
  const { type, data, fetchError } = action;

  switch (type) {
  case types.REGIONAL_FEES_FETCH_REQUEST: {
    return { ...state,
      isFetching: true
    }
  }

  case types.REGIONAL_FEES_FETCH_SUCCESS: {
    return { ...state,
      isFetching: false,
      hasFetched: true,
      feeTypes: data.fees,
      regions: data.regions
    }
  }

  case types.REGIONAL_FEES_FETCH_FAILURE: {
    return { ...state,
      isFetching: false,
      hasFetched: true,
      error: fetchError
    }
  }

  default:
    return state;
  }
}
